<template>
  <main>
    <v-tabs show-arrows>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">Profile</v-tab>
      <v-tab href="#tab-2"  v-if="showPassword === true">Password</v-tab>
      <v-tab href="#tab-3">Preferences</v-tab>

      <v-tab-item :value="'tab-1'" :key="1">
        <UserProfileImage />
        <UserProfile />
      </v-tab-item>

      <v-tab-item  v-if="showPassword === true" :value="'tab-2'" :key="2">
        <UserProfilePassword />
      </v-tab-item>
      
      <v-tab-item :value="'tab-3'" :key="3">
        <UserProfileContactPrefs />
      </v-tab-item>

    </v-tabs>

    <FooterShout :type="'help'"/>
  </main>
</template>

<script>
  import UserProfile from '@/components/UserProfile'
  import UserProfilePassword from '@/components/UserProfilePassword'
  import UserProfileClientRefNo from '@/components/UserProfileClientRefNo'
  import UserProfileImage from '@/components/UserProfileImage'
  import UserProfileContactPrefs from '@/components/UserProfileContactPrefs'
  import UserProfileMembership from '@/components/UserProfileMembership'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      UserProfile,
      UserProfilePassword,
      UserProfileClientRefNo,
      UserProfileImage,
      UserProfileContactPrefs,
      UserProfileMembership,
      FooterShout
    },
    data () {
      return {
        showPassword: false,
        showMembership: false
      }
    },
    mounted () {
        console.log('User Profile component loaded')
        
        if(this.$getAuthenticatedUser() == null){
          console.log('User is not logged in')
          this.$router.push("/");
        } else {
          // check to see if the user was created with traditional registration (and not Facebook or Google)
          this.$getCurrentUserAttributes().subscribe((userData) => {
            if(userData.email_verified){
              console.log('user allowed to change password')
              this.showPassword = true //if they did register with their email, then let them change password
            } 
          })
        }
        console.log(this.$root.$data.referrer)
    }
  }
</script>
